import { lsgetItem } from "./localStorageHelper";

export function authHeader(headers) {
  // return authorization header with jwt token
  let user = lsgetItem('user'); /* JSON.parse(localStorage.getItem("user")); */

  if (user && user.token) {
    if(user.oid === undefined)
      user.oid = 0;
    if(user.eid === undefined)
      user.eid = 0;
      if(user.userLang === undefined)
      user.userLang = "swe"
    return { ...headers, Authorization: "Bearer " + user.token.toString(), eid: user.eid, oid:user.oid, userLang: user.userLang };
  } else {
    return headers;
  }
}


